import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import CourseCodeRegistration from '../components/CourseCodeRegistration';
import authService from '../services/authService';

const CourseCodeRegistrationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const childId = searchParams.get('childId');
  const currentUser = authService.getCurrentUser();

  const userType = currentUser?.userType === 'PARENT' ? 'parent' : 'student';
  const userId = childId || currentUser?.id?.toString() || '';

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', px: 2 }}>
      <Breadcrumbs sx={{ mt: 3, mb: 1 }}>
        <Link
          underline="hover"
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate(userType === 'parent' ? '/parent-dashboard' : '/student-dashboard')}
        >
          Dashboard
        </Link>
        <Typography color="text.primary">Join with a code</Typography>
      </Breadcrumbs>
      <CourseCodeRegistration
        userType={userType}
        userId={userId}
        childId={childId || undefined}
      />
    </Box>
  );
};

export default CourseCodeRegistrationPage;
